import { render, staticRenderFns } from "./table1.vue?vue&type=template&id=fb569878&scoped=true"
import script from "./table1.vue?vue&type=script&lang=js"
export * from "./table1.vue?vue&type=script&lang=js"
import style0 from "./table1.vue?vue&type=style&index=0&id=fb569878&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb569878",
  null
  
)

export default component.exports